var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCableTv = function SvgCableTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M11.517 6.08c.902 0 2.206.793 2.206 2.557M11.742 4.029c1.624 0 3.973 1.43 3.973 4.606"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M11.984 1.995c2.384 0 5.835 2.1 5.835 6.766"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M4.729 14.9a6.72 6.72 0 0 1 .34-9.495.5.5 0 0 1 .707.026l8.474 9.103a.5.5 0 0 1-.025.706 6.72 6.72 0 0 1-9.496-.34Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M11.086 8.83a1.075 1.075 0 0 1-.053 1.52.5.5 0 0 1-.707-.025l-.784-.842a.5.5 0 0 1 .024-.706 1.075 1.075 0 0 1 1.52.053Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.5 19.5 2-3c1.68.674 2.717.812 4.5.5l1.5 2.5z"
  })));
};
export default SvgCableTv;